import styled from '@emotion/styled';
import { ob } from '../onboardingV2.tokens';

export const SavedList = styled.ul`
    list-style: none;
    margin: 4px 0 18px;
    padding: 0;
    border: 1px solid ${ob.color.borderSubtle};
    border-radius: ${ob.radius.md};
    overflow: hidden;
`;

export const SavedTitle = styled.p`
    margin: 0 0 8px;
    font-size: 14px;
    font-weight: 600;
    color: ${ob.color.text};
`;

export const SavedRow = styled.li`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 12px;
    background: ${ob.color.surface};

    & + & {
        border-top: 1px solid ${ob.color.borderSubtle};
    }

    .info {
        flex: 1;
        min-width: 0;
    }

    .name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;
        font-weight: 600;
        color: ${ob.color.text};
    }

    .meta {
        font-size: 13px;
        color: ${ob.color.muted};
        font-variant-numeric: tabular-nums;
    }
`;

export const SavedThumb = styled.span`
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: ${ob.radius.sm};
    background:
        ${(props) => (props.src ? `center / cover no-repeat url(${props.src}),` : '')}
        ${ob.color.subtle};
    color: ${ob.color.muted};
    font-size: 18px;
`;

export const RowAction = styled.button`
    flex-shrink: 0;
    background: none;
    border: 0;
    padding: 6px;
    font-size: 13px;
    font-weight: 600;
    color: ${ob.color.brand};
    cursor: pointer;

    i {
        font-size: 16px;
    }

    &:focus-visible {
        outline: none;
        border-radius: ${ob.radius.sm};
        box-shadow: 0 0 0 3px ${ob.color.lime200};
    }
`;

export const AddAnother = styled.div`
    margin-top: 4px;
`;

export const Select = styled.select`
    flex: 1;
    width: 100%;
    height: 49px;
    padding: 0 40px 0 16px;
    border: 0;
    border-radius: ${ob.radius.md};
    background: transparent;
    font-size: 16px;
    color: ${ob.color.text};
    appearance: none;
    cursor: pointer;
    outline: none;
`;

export const SelectChevron = styled.i`
    position: absolute;
    right: 14px;
    pointer-events: none;
    font-size: 18px;
    color: ${ob.color.muted};
`;
